export enum Actor {
	USER = 'user',
	AUTOMATION = 'automation'
}
